import { createStore } from '../core/store';
import { useApp } from '../react/app';
import { useStore } from '../react/useStore';
import type { VoiceState } from './controller';

/** The state of a kiosk without voice (operator, replay, no microphone): always off. */
const NO_VOICE = createStore<VoiceState>('voice-off', { connection: 'off', activity: 'idle', microphone: false, replying: false, error: null });

export function useVoice<T>(select: (v: VoiceState) => T): T {
  const { voice } = useApp();
  return useStore(voice?.state ?? NO_VOICE, select);
}
